module.exports = __webpack_public_path__ + "static/media/jianglixize651.5f7f9e61.png";